"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deCompanyNumberChecker = void 0;
var HRB_REGEX = /^HRB\d+$/;
var deCompanyNumberChecker = exports.deCompanyNumberChecker = function deCompanyNumberChecker(companyNumber) {
  return HRB_REGEX.test(companyNumber);
};